import { Component, OnInit } from '@angular/core';
import { GscService } from '../services/gsc/gsc.service';
import { NavController, LoadingController } from '@ionic/angular';

@Component({
  selector: 'app-local-pdf-view',
  templateUrl: './local-pdf-view.page.html',
  styleUrls: ['./local-pdf-view.page.scss'],
})
export class LocalPdfViewPage implements OnInit {

  constructor(public gsc: GscService, private navCtrl: NavController, private loadingCtrl: LoadingController) { }

  ngOnInit() {
    this.loadingCtrl.create({duration: 2000}).then(loading => loading.present());
  }
  goBack(){
    this.navCtrl.navigateBack('/abstracts');
  }

}
